import { useEffect, useRef } from "react";
import { Requirements } from "../../../../services/GroupGrowth/groupGrowth.types";
import { SsiEligibilityWindowExtended } from "../../../../services/SSIUpline/ssiUplineAPI.types";
import InWindowTable from "../InWindowTable/InWindowTable";
import { InWindowCard } from "../InWindowCard/InWindowCard";
import "./InWindowWrapper.scss";

export type Row = {
  AboName: string;
  AboNum: string;
  Aff: string;
  Requirements: Requirements;
  EligibilityWindow: SsiEligibilityWindowExtended;
  SponsorName: string;
  SponsorNum: string;
  IsHighlighted?: boolean;
  scrollRef?: boolean;
};

type Props = {
  rows: Row[];
  isLoading: boolean;
  selectedAboNumber: string;
  viewType: "mobile" | "desktop";
};

export const InWindowWrapper = ({ rows, isLoading, selectedAboNumber, viewType }: Props) => {
  if (!isLoading && rows.length === 0) {
    return <></>;
  }

  const InWindowCardListRenderer = () => {
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, [scrollRef]);

    return (
      <div className="InWindowWrapper">
        {isLoading && (
          <InWindowCard
            key={`isLoading_ssi_upline_inWindow_card`}
            row={{
              AboName: "",
              AboNum: "",
              Aff: "",
              Requirements: {
                VolumeRequirements: [],
                PercentRequirements: [],
                TotalRequirements: 0,
                RequirementsMet: 0,
                RequirementMetStatuses: [],
              },
              EligibilityWindow: {
                EntryPeriod: "",
                StartPeriod: "",
                EndPeriod: "",
                CurrentYear: [],
                NextYear: [],
                MarketHasGracePeriod: false,
                AchievedMonths: 0,
                AchievedMonthsWithGrace: 0,
                PaymentsEarned: 0,
                PayDayMonths: [],
              },
              SponsorName: "",
              SponsorNum: "",
              IsHighlighted: false,
            }}
            isLoading={true}
          />
        )}
        {rows.map((row, ind) => (
          <div key={`${row.AboNum}-${ind}`} ref={row.scrollRef ? scrollRef : null}>
            <InWindowCard row={row} isLoading={isLoading} />
          </div>
        ))}
      </div>
    );
  };

  return viewType === "mobile" ? (
    <InWindowCardListRenderer />
  ) : (
    <InWindowTable rows={rows} isLoading={isLoading} selectedAboNumber={selectedAboNumber} />
  );
};
